import { useIsMobile } from '@/hooks/use-mobile'
import { MarketIndicatorBaseProps } from './MarketIndicatorBase'
import { MarketIndicatorMobile } from './MarketIndicatorMobile'
import { MarketIndicatorDesktop } from './MarketIndicatorDesktop'

/**
 * Unified MarketIndicator component that renders mobile or desktop version
 * Uses useIsMobile hook to conditionally render the appropriate version
 * This approach separates mobile and desktop code completely
 */
export const MarketIndicator = (props: MarketIndicatorBaseProps) => {
  const isMobile = useIsMobile()

  // Completely separate mobile and desktop rendering
  // No CSS classes mixing - pure conditional rendering
  if (isMobile) {
    return <MarketIndicatorMobile {...props} />
  }

  return <MarketIndicatorDesktop {...props} />
}

